module.exports = __webpack_public_path__ + "static/media/CopperMedalIcon.90390fd0.svg";